import { ErrorMarkup } from 'modules/error';
import { useSendingPlatformsQueryContext } from '../../../contexts';
import { CUSTOM_EMAIL } from '../../../constants';
import { Sidebar } from '../Sidebar';
import { EmailAccountsHeader } from './EmailAccountsHeader';
import { EmailAccountsSection } from './EmailAccountsSection';
import { EmailModals } from './EmailModals';
import { CustomEmailPageHeader } from './CustomEmailPageHeader';
import { Wrapper, MainContent } from '../Page.styled';

export const CustomEmailPage = () => {
  const { hasError, isLoadingEssentialData } = useSendingPlatformsQueryContext();

  if (hasError)
    return (
      <ErrorMarkup
        id="sending-platforms-details-error-page"
        fallbackLinkTo="/settings/sendingPlatforms"
        fallbackLinkToText="Back to Sending Platforms"
      />
    );

  return (
    <>
      <div>
        <CustomEmailPageHeader />
        <Wrapper>
          <Sidebar sendingPlatform={CUSTOM_EMAIL} />
          <MainContent>
            <EmailAccountsHeader sendingPlatform={CUSTOM_EMAIL} />
            <EmailAccountsSection sendingPlatform={CUSTOM_EMAIL} />
          </MainContent>
        </Wrapper>
      </div>
      {!isLoadingEssentialData && <EmailModals />}
    </>
  );
};
